const CANONICAL_DOMAIN = 's.mote.com'

export const API_BASE_URL =
  process.env.REACT_APP_BASE_URL ||
  process.env.STORYBOOK_REACT_APP_BASE_URL ||
  `https://${CANONICAL_DOMAIN}/`
